import { render, staticRenderFns } from "./SPRGroupOrganizersDropdown.vue?vue&type=template&id=03100f92"
import script from "./SPRGroupOrganizersDropdown.vue?vue&type=script&lang=js"
export * from "./SPRGroupOrganizersDropdown.vue?vue&type=script&lang=js"
import style0 from "./SPRGroupOrganizersDropdown.vue?vue&type=style&index=0&id=03100f92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports